import { Appender } from "../Appender";
import { LoggingEvent } from "../LoggingEvent";
import { LoggingLevel } from "../LoggingLevel";

/**
 * Функция передаваемая пользователем аппендера, с помощью которой осуществляется отправка запроса на сервер.
 */
export type PostRequest = (url: string, body: any) => Promise<any>;

/**
 * Данный appender отвечает за отправку логгов по HTTP на сервер методом POST.
 *
 * Для работы appender требуются передать функцию, отправлющую POST запросы на сервер {@link executePostRequest},
 * и ссылку {@link loggerUrl} на которую будут отправляться запросы.
 */
export class HttpAppender implements Appender {
  /**
   * Функция которая отправляет POST запрос на сервер.
   * Задается при создании аппендера.
   */
  private readonly executePostRequest: PostRequest;

  /**
   * URL на который будут отправляться запросы.
   */
  private readonly loggerUrl: string;

  /**
   * Создание обработчика для отправки логгов на сервер.
   *
   * @param executePostRequest - функция отправляющия POST запросы на сервер.
   * @param loggerUrl - URL на который отправляются запросы.
   */
  constructor(executePostRequest: PostRequest, loggerUrl: string) {
    this.executePostRequest = executePostRequest;
    this.loggerUrl = loggerUrl;
  }

  /**
   * Отправляет POST запрос с логгом на сервер.
   * .catch() перехватывает неудачные попытки отправки запросов на сервер.
   * Используется для того, чтобы неудачная отправка данных на сервер не приводила к отправке новой ошибки (бесконечный цикл).
   */
  public doAppend(event: LoggingEvent) {
    this.executePostRequest(this.loggerUrl, this.formRequestBody(event)).catch(
      (e) => {
        console.warn("Cannot send log to server:", e);
      }
    );
  }

  /**
   * Преобразует в теле запроса LoggingLevel из number в значение из {@link LoggingLevel}
   * 3 -> "INFO"
   */
  private formRequestBody(body: LoggingEvent) {
    return {
      ...body,
      level: LoggingLevel[body.level],
    };
  }
}
